"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var HelperText_component_exports = {};
__export(HelperText_component_exports, {
  HelperText: () => HelperText,
  default: () => HelperText_component_default
});
module.exports = __toCommonJS(HelperText_component_exports);
var import_jsx_runtime = require("react/jsx-runtime");
var import_TriangleWarning = __toESM(require("@greatmindsorg/gmui-icons-lib/dist/TriangleWarning"));
var import_Info = __toESM(require("@greatmindsorg/gmui-icons-lib/dist/Info"));
var import_baseTheme = require("../../baseTheme");
var import_clsx = __toESM(require("clsx"));
const HelperText = ({
  id,
  validationError,
  helperText,
  role = "status",
  ariaLive,
  isInvalid
}) => {
  const icon = isInvalid ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
    import_TriangleWarning.default,
    {
      title: "warning-icon",
      iconSize: "s",
      color: import_baseTheme.baseTheme.theme.colors.error110
    }
  ) : helperText && !isInvalid ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_Info.default, { title: "info-icon", iconSize: "s", color: import_baseTheme.baseTheme.theme.colors.neutral110 }) : null;
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(
    "div",
    {
      className: (0, import_clsx.default)("mt-2", "flex", "gap-1.5"),
      id,
      role: isInvalid ? "alert" : role,
      "aria-live": ariaLive,
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
          "div",
          {
            "aria-hidden": "true",
            className: (0, import_clsx.default)("flex", "justify-center", "mt-[3px]"),
            style: { lineHeight: "14px" },
            children: icon
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
          "span",
          {
            className: (0, import_clsx.default)(
              "gmui-font-style-body-compact",
              isInvalid ? "text-[--color-content-support-error-subtle]" : "text-[--color-content-interactive-help-text]"
            ),
            children: isInvalid ? validationError : helperText
          }
        )
      ]
    }
  );
};
var HelperText_component_default = HelperText;
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  HelperText
});
//# sourceMappingURL=HelperText.component.js.map